import { Accordion } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ActiveReferenceFilter";
var classes = {
    accordionSummaryRoot: "".concat(PREFIX, "-accordionSummaryRoot"),
    accordionSummaryRootExpanded: "".concat(PREFIX, "-accordionSummaryRootExpanded"),
    accordionSummaryContent: "".concat(PREFIX, "-accordionSummaryContent"),
    accordionSummaryContentExpanded: "".concat(PREFIX, "-accordionSummaryContentExpanded"),
    expanded: "".concat(PREFIX, "-expanded"),
    refDetails: "".concat(PREFIX, "-refDetails"),
    filter: "".concat(PREFIX, "-filter"),
    genCodeCount: "".concat(PREFIX, "-genCodeCount"),
    refNotFound: "".concat(PREFIX, "-refNotFound"),
    dropIcon: "".concat(PREFIX, "-dropIcon"),
    closeButton: "".concat(PREFIX, "-closeButton"),
    accordionDetailsRoot: "".concat(PREFIX, "-accordionDetailsRoot"),
    refList: "".concat(PREFIX, "-refList"),
    refNotFoundIcon: "".concat(PREFIX, "-refNotFoundIcon"),
    refNotFoundDetails: "".concat(PREFIX, "-refNotFoundDetails"),
    copyButton: "".concat(PREFIX, "-copyButton")
};
var StyledAccordion = styled(Accordion)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            backgroundColor: theme.palette.background.paper,
            border: "1px solid ".concat(theme.palette.grey[400]),
            borderRadius: theme.shape.borderRadius,
            margin: theme.spacing(1, 0, 1, 0),
            boxShadow: "none"
        },
        _b["& .".concat(classes.accordionSummaryRoot)] = {
            padding: theme.spacing(0.5, 1)
        },
        _b["& .".concat(classes.accordionSummaryRootExpanded)] = {
            padding: theme.spacing(0.5, 1),
            borderBottom: "1px solid ".concat(theme.palette.grey[400])
        },
        _b["& .".concat(classes.accordionSummaryContent)] = {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            margin: 0
        },
        _b["& .".concat(classes.accordionSummaryContentExpanded)] = (_c = {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
            },
            _c["&.".concat(classes.expanded)] = {
                margin: 0,
                minHeight: "fit-content"
            },
            _c),
        _b["&.".concat(classes.expanded)] = {},
        _b["& .".concat(classes.refDetails)] = {
            display: "flex"
        },
        _b["& .".concat(classes.filter)] = {
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(0, 0.5, 0, 0.5)
        },
        _b["& .".concat(classes.genCodeCount)] = {
            color: theme.palette.primary.main
        },
        _b["& .".concat(classes.refNotFound)] = {
            marginLeft: theme.spacing(0.5),
            backgroundColor: theme.palette.error.dark
        },
        _b["& .".concat(classes.dropIcon)] = {
            alignSelf: "center"
        },
        _b["& .".concat(classes.closeButton)] = {
            alignSelf: "center"
        },
        _b["& .".concat(classes.accordionDetailsRoot)] = {
            padding: 0
        },
        _b["& .".concat(classes.refList)] = {
            width: "100%"
        },
        _b["& .".concat(classes.refNotFoundIcon)] = {
            color: theme.palette.error.dark,
            overflow: "hidden"
        },
        _b["& .".concat(classes.refNotFoundDetails)] = {
            color: theme.palette.error.dark,
            overflow: "hidden"
        },
        _b["& .".concat(classes.copyButton)] = {
            alignSelf: "center",
            paddingRight: 0
        },
        _b);
});

export { classes, StyledAccordion as default };
//# sourceMappingURL=index.styled.js.map
